// extracted by mini-css-extract-plugin
module.exports = {"modalBackground":"BaseModal_modalBackground__3hV51","modal":"BaseModal_modal__3kTt3","closeButton":"BaseModal_closeButton__6H6L2"};